// removed by extract-text-webpack-plugin
module.exports = {"container":"_8-sm","curve":"_1h09","up":"_25rc","down":"_30L1","content":"_3tHH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CurveWrapper/styles.scss
// module id = 434
// module chunks = 0